// @flow

import { type IncomingPayment } from './types';
import { getPaymentFromApi } from '@tectonics/prs/incoming-payment';
import { normalizeIncomingPayment } from './normalize';

export async function fetchIncomingPayment(hash: string, localTenancy?: string): Promise<IncomingPayment> {
  const rawIncomingPayment = await getPaymentFromApi(hash, localTenancy);
  const incomingPayment = normalizeIncomingPayment(rawIncomingPayment);
  return incomingPayment;
}
